import RU from './ru.json';
import TRY from './try.json';
import GEL from './gel.json';
import UZ from './uz.json';
import KZ from './kz.json';

export const translate = (value) => {
    const language = localStorage.getItem('language');
    switch (language) {
        case 'kz': {
            if (!KZ[value]) {
                return value
            }
            return KZ[value];
        }
        case 'try': {
            if (!TRY[value]) {
                return value
            }
            return TRY[value]; 
        }
        case 'gel': {
            if (!GEL[value]) {
                return value
            }
            return GEL[value]; 
        }
        case 'uz': {
            if (!UZ[value]) {
                return value
            }
            return UZ[value]; 
        }
        default: {
            if (!RU[value]) {
                return value
            }
            return RU[value]; 
        }
    }
}